export const FETCH_PACKAGES = "FETCH_PACKAGES";
export const BUY_PACKAGES = "BUY_PACKAGES";
export const VERIFY_PACKAGES = "VERIFY_PACKAGES";
